import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'

export const providesList = (ids, tagType) => {
  //console.log('[providesList] ids =', ids)
  if (ids) {
    const tagsList = ids.map((id) => {
      return { type: tagType, id }
    })
    return [...tagsList, { type: tagType, id: 'LIST' }]
  }
}

// initialize an empty api service that we'll inject endpoints into later as needed
export const api = createApi({
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_API_BASE_URL,
    prepareHeaders: (headers, { getState }) => {
      const token = getState().auth.token
      if (token) {
       // include token in req header
        headers.set('Authorization', `Bearer ${token}`) 
        //console.log('prepared headers', headers.get('Authorization'))
        return headers
      }
    }
  }),
  endpoints: () => ({}),
})
